import Fetcher from "../libs/Petition"

const url = '/purchase_order/items';
const CREATED = 201;
const STATUS_OK = 200;

/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param purchase_order_id Identificador de la orden de compra de la que se ontendrán las partidas
 * @returns Object {"data" => PurchaseOrder::collection(),"totalItems" => Cantidad de registros existentes}
 */
export const indexPurchaseOrderItem = async ({ headers, purchase_order_id }) => {
    let response = [];
    try {
        let params = { purchase_order_id};
        let fetch = await Fetcher({
            url: `${url}`,
            method: 'GET',
            params,
            headers
        });
        if (fetch.status === STATUS_OK)
            response = fetch.data;
    } catch (error) {
        response = [];
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param item_id Identificador del item la orden de compra sobre el que se hará la consulta
 * @returns PurchaseOrderItem Retorna un objeto tipo PurchaseOrderItem
 */
export const showPurchaseOrderItem = async ({ headers, item_id }) => {
    let response = [];
    try {
        let fetch = await Fetcher({
            url: `${url}/${item_id}`,
            method: 'GET',
            headers
        });
        if (fetch.status === STATUS_OK)
            response = fetch.data.data;
    } catch (error) {
        response = [];
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param data Contiene el objeto que se va a almacenar 
 * @returns Bool Retorna true si el objeto se almacena de manera satisfactoria, retorna FALSE si el objeto no se pudo almacenar 
 */
export const storePurchaseOrderItem = async ({ headers, data }) => {
    let response = true;
    try {
        let fetch = await Fetcher({
            url: `${url}`,
            method: 'POST',
            data,
            headers
        });
        if (fetch.status !== CREATED)
            response = false;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param data Contiene el objeto que se va a actualizar
 * @param item_id Identificador del item de la orden de compra que se va a modificar
 * @returns Bool Retorna true si el objeto se actualiza de manera satisfactoria, retorna FALSE si el objeto no se pudo actualizar 
 */
export const updatePurchaseOrderItem = async ({ headers, data, item_id }) => {
    let response = true;
    try {
        let fetch = await Fetcher({
            url: `${url}/${item_id}`,
            method: 'PUT',
            data,
            headers
        });
        if (fetch.status !== STATUS_OK)
            response = false;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param item_id Identificador del item de la orden de compra que se va a eliminar
 * @returns Bool Retorna true si el objeto se elimina de manera satisfactoria, retorna FALSE si el objeto no se pudo eliminar 
 */
export const destroyPurchaseOrderItem = async ({ headers, item_id }) => {
    let response = true;
    try {
        let fetch = await Fetcher({
            url: `${url}/${item_id}`,
            method: 'DELETE',
            headers
        });
        if (fetch.status !== STATUS_OK)
            response = false;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}